import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h3>{{i18n this.title}}</h3>\n<ul>\n  {{yield}}\n</ul>",{ moduleName: "discourse/components/popup-menu.hbs" })